import React, { Component } from 'react';
import { Link } from "react-router-dom";
import ManifestMapArcGIS from "./ManifestMapArcGIS";
import {
  Alert,
  Row,
  Col,
  Form,
  InputGroup,
  Button,
} from "react-bootstrap";
import {
  ManifestDetail,
  TransporterDetails,
  WasteStreamDetails,
  ManifestImages,
  DownloadManifestCsv,
} from "./";
import { copyType } from "./Config";
import { Loading } from "../../shared";
import AxiosCallCellRenderer from "./AxiosCallCellRenderer";
import PreviewImgCellRenderer from "./PreviewImgCellRenderer";

class ManifestDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      manifestId: "",
      columnDefs: [
        { headerName: "Stream No", field: "LINE_NO", sort: "asc" },
        {
          headerName: "RCRA",
          field: "RCRA_CODE",
          width: 200,
        },
        { headerName: "Non-RCRA", field: "WASTE_STATE_CODE" },
        { headerName: "Method", field: "METH_CODE" },
        { headerName: "Containers", field: "NBR_CONTR" },
        { headerName: "Type", field: "CONTR_TYPE_CODE" },
        { headerName: "Quantity", field: "WASTE_QNTY" },
        { headerName: "Unit", field: "QNTY_UNIT" },
        { headerName: "Tons", field: "CONV_QNTY_TONS" },
      ],
      columnDefsImages: [
        {
          headerName: "Image Preview",
          field: "ManifestID",
          cellRenderer: 'PreviewImgCellRenderer',
        },
        {
          headerName: "Manifest",
          field: "ManifestID",
          cellRenderer: 'axiosCallCellRenderer',
        },
        {
          headerName: "Type",
          field: "CopyType",
          cellRenderer: copyType,
          sort: "dsc",
        },
      ],
      frameworkComponents: {
        axiosCallCellRenderer: AxiosCallCellRenderer,
        PreviewImgCellRenderer: PreviewImgCellRenderer
      },

      columnDefsImagesRegulator: [
        {
          headerName: "Image Preview",
          field: "ManifestID",
          cellRenderer: 'PreviewImgCellRenderer'
        },
        {
          headerName: "Manifest",
          field: "ManifestID",
          cellRenderer: 'axiosCallCellRenderer',
        },
        {
          headerName: "Type",
          field: "CopyType",
          cellRenderer: copyType,
          sort: "dsc",
        },
        { headerName: "Roll", field: "RollNo" },
        { headerName: "Frame", field: "FrameNo" },
        { headerName: "Batch", field: "BatchDate" },
        { headerName: "CD", field: "DPath" },
        { headerName: "File Name", field: "FileName" },
      ],
    };

    this.onSearchManifestSubmit = this.onSearchManifestSubmit.bind(this);
    this.onSerachManifstHandleChange = this.onSerachManifstHandleChange.bind(this);
  }

  componentDidMount() { }

  onGridReady = (params) => {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
    this.api.setDomLayout("autoHeight");
    this.api.refreshCells();
  };

  onFirstDataRendered = (params) => {
    var allColumnIds = [];
    this.columnApi.getAllColumns().forEach((column) => {
      allColumnIds.push(column.colId);
    });
    this.columnApi.autoSizeColumns(allColumnIds, false);
    params.api.sizeColumnsToFit();
    //params.api.setDomLayout('print');
  };

  getRowStyle = (params) => {
    if (params.node.rowIndex % 2 === 1) {
      return { "background-color": "#eaf3f9" };
    }
  };

  toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  formatDate(date) {
    let formattedDate = new Date(date).toLocaleDateString();
    return formattedDate;
  }

  onSearchManifestSubmit = (e) => {
    e.preventDefault();
    this.props.onSearchManifest(this.state.manifestId);
  };

  onSerachManifstHandleChange = (e) => {
    e.preventDefault();
    this.setState({ ...this.state, manifestId: e.target.value });
  };

  render() {
    return (
      <React.Fragment>
        <div className="manifest-details">
          <Row>
            <Col>
              <ol
                className="breadcrumb mb-0 mr-4"
              // style={{ fontSize: "1.5rem" }}
              >
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/reports/manifest">Manifests</Link>
                </li>
                <li>
                  {this.props.Manifest ? this.props.Manifest.MANIFEST_ID : ""}
                </li>
              </ol>
            </Col>
            <Col md={{ span: 3, offset: 3 }}>
              <Form
                onSubmit={this.onSearchManifestSubmit}
                style={{ paddingTop: 5 }}
              >
                <Form.Row>
                  <Col>
                    <InputGroup>
                      <Form.Control
                        placeholder="Search for a Manifest"
                        aria-label="Search for a Manifest"
                        aria-describedby="basic-addon2"
                        type="text"
                        onChange={this.onSerachManifstHandleChange}
                        id="manifestId"
                        name="manifestId"
                      />
                      <InputGroup.Append>
                        <Button
                          disabled={this.props.isFetching}
                          type="submit"
                          variant="outline-secondary"
                          style={{ height: "38px", borderColor: "#a8b3bd" }}
                        >
                          <span className="ca-gov-icon-search formearch">
                            <span className="sr-only">Search</span>
                          </span>
                        </Button>
                      </InputGroup.Append>
                    </InputGroup>
                  </Col>
                </Form.Row>
              </Form>
            </Col>
          </Row>
          <hr style={{ marginTop: 0 }} />
          {this.props.Manifest && this.props.Manifest.ORIGIN_TYPE === "" &&
            <Row className="mx-0 mb-2">
              <Alert className="full-width mb-0" variant="danger">
                Only the image of the manifest submitted to DTSC is available at this time. Our records indicate the facility copy of the manifest and data has not been submitted to or released by the U.S. EPA e-Manifest system.
              </Alert>
            </Row>
          }
          <Row className="mx-0">
            <div className="mr-auto">
              {this.props.Manifest ? (
                <Form.Group className="mb-2">
                  <Form.Row>
                    <Form.Label
                      size="sm"
                      column
                      lg={2}
                      xs={2}
                      style={{ lineHeight: "13px" }}
                      className="mr-5"
                    >
                      Version:{" "}
                    </Form.Label>
                    <Form.Control
                      size="sm"
                      onChange={this.props.onVersionChange}
                      as="select"
                      value={this.props.Manifest.VERSION_ID}
                      style={{ width: 75 }}
                    >
                      {this.props.manifestVersion.map((v, key) => {
                        return (
                          <option key={key} value={v}>
                            {v}
                          </option>
                        );
                      })}
                    </Form.Control>
                  </Form.Row>
                </Form.Group>
              ) : (
                  <div></div>
                )}
            </div>
            <div className="ml-auto">
              {this.props.Manifest && (
                <div style={{ float: "right", top: 5 }}>
                  <DownloadManifestCsv
                    isFetching={this.props.isFetching}
                    MANIFEST_ID={this.props.Manifest.MANIFEST_ID}
                    COPY_TYPE_IND={this.props.Manifest.COPY_TYPE_IND}
                  />
                </div>
              )}
            </div>
          </Row>
          {this.props.isFetching ? (
            <div style={{ paddingBottom: 100 }}>
              <Loading />
            </div>
          ) : (
              <div>
                {!this.props.Manifest ? (
                  <div>
                    <p style={{ textAlign: "center" }}>No Manifest Found</p>
                  </div>
                ) : (
                    <div>
                      <Row>
                        <Col md="6">
                          <ManifestDetail Manifest={this.props.Manifest} />
                        </Col>
                        <Col md="6">
                          <TransporterDetails Manifest={this.props.Manifest} />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <WasteStreamDetails
                            onGridReady={this.onGridReady}
                            state={this.state}
                            wasteStreams={this.props.wasteStreams}
                            onFirstDataRendered={this.onFirstDataRendered}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <ManifestImages
                            onGridReady={this.onGridReady}
                            isRegulator={this.props.isRegulator}
                            columnDefsImagesRegulator={
                              this.state.columnDefsImagesRegulator
                            }
                            columnDefsImages={this.state.columnDefsImages}
                            manifestImages={this.props.manifestImages}
                            frameworkComponents={this.state.frameworkComponents}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          {this.props.GENERATOR &&
                            this.props.GENERATOR.DDLatitude > 0 &&
                            this.props.TSDF &&
                            this.props.TSDF.DDLatitude > 0 &&
                            this.props.GENERATOR.EpaId !== this.props.TSDF.EpaId ? (
                              <div
                                className="full-width manifest-search-result-map m-t-sm"
                                style={{ height: "300px", marginBottom: 12 }}
                              >
                                <ManifestMapArcGIS
                                  Manifest={this.props.Manifest}
                                  GENERATOR={this.props.GENERATOR}
                                  TSDF={this.props.TSDF}
                                />
                              </div>
                            ) : null}
                        </Col>
                      </Row>
                    </div>
                  )}
              </div>
            )}
          <div className="manifest-info-disclaimer">
            <p>
              The Department of Toxic Substances Control(DTSC) takes every
              precaution to ensure the accuracy of data in the Hazardous Waste
              Tracking System(HWTS).However, because of the large number of
              manifests handled, inaccuracies in the submitted data, limitations
              of the manifest system and the technical limitations of the
              database, DTSC cannot guarantee that the data accurately reflect
              what was actually transported or produced.
            </p>
          </div>
        </div>

        {/* <div className="full-width"> */}
        {/* <div className="manifest-print">
        <a
          href={`https://hwts.dtsc.ca.gov/hwts_Reports/ReportPages/Report06.aspx?manifestid=${this.props.Manifest.MANIFEST_ID}`}
          target="_"
        >
          Print Manifest Profile
      </a>
      </div> */}
        {/* </div> */}
      </React.Fragment>
    );
  }
}

export default ManifestDetails;
